import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCursor3"><Path d="M20.629 8.43162L2.04102 2.04199L8.43065 20.63L11.7495 17.3111L16.7495 22.3111L22.3102 16.7505L17.3102 11.7505L20.629 8.43162Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursor3;
